import { SREV2 } from '../../../api/pushGenie';
import { getAclViewClassName } from '../../../restrictions/utils';

const MedicalCertificatesBt: React.FC<{
    isSelected: boolean;
    onClick: () => void;
}> = ({ onClick, isSelected }) => {
    return (
        <div
            onClick={onClick}
            className={`menuitem ${isSelected ? 'selected' : ''} ${getAclViewClassName(
                SREV2.CREATE_MEDICAL_DOCUMENTS,
            )}`}
        >
            <div>
                <div>
                    <svg
                        width="12"
                        height="14"
                        viewBox="0 0 448 512"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M402 2.22c-8.5-3.953-18.53-2.547-25.66 3.578l-39.13 33.53l-32.28-32.28C296.5-1.42 283.1-2.342 273.6 4.814L224 42.01l-49.59-37.2C164.9-2.311 151.5-1.389 143 7.048L110.8 39.33L71.63 5.798c-7.109-6.125-17.17-7.531-25.66-3.578C37.45 6.126 32 14.64 32 24.02v463.1c0 9.374 5.453 17.89 13.97 21.8c8.484 3.937 18.55 2.531 25.66-3.578l39.13-33.53l32.28 32.28c8.438 8.468 21.81 9.359 31.38 2.234L224 469.1l49.59 37.2c9.562 7.156 22.92 6.265 31.38-2.234l32.28-32.28l39.13 33.53c4.438 3.812 10 5.781 15.62 5.781c3.406 0 6.828-.7187 10.03-2.203C410.5 505.9 416 497.4 416 487.1V24.02C416 14.64 410.5 6.126 402 2.22zM368 435.8l-16.38-14.03c-9.531-8.171-23.7-7.625-32.59 1.25l-33.28 33.28L238.4 420.8C234.1 417.6 229.1 415.1 224 415.1S213.9 417.6 209.6 420.8l-47.34 35.51l-33.28-33.28c-8.875-8.874-23.05-9.421-32.59-1.25L80 435.8V76.2L96.38 90.23c9.547 8.187 23.72 7.656 32.59-1.25l33.28-33.28l47.34 35.51c8.531 6.406 20.28 6.406 28.81 0l47.34-35.51l33.28 33.28c8.891 8.906 23.06 9.437 32.59 1.25L368 76.2V435.8zM312 160h-176c-8.844 0-16 7.156-16 15.1s7.156 15.1 16 15.1h176c8.844 0 16-7.156 16-15.1S320.8 160 312 160zM312 319.1h-176c-8.844 0-16 7.156-16 15.1c0 8.843 7.156 15.1 16 15.1h176c8.844 0 16-7.156 16-15.1C328 327.2 320.8 319.1 312 319.1zM312 240h-176c-8.844 0-16 7.156-16 15.1c0 8.843 7.156 15.1 16 15.1h176c8.844 0 16-7.156 16-15.1C328 247.2 320.8 240 312 240z"
                            fill="#004BA8"
                        ></path>
                    </svg>
                </div>
                <p>Medical Documents</p>
            </div>
            <div>
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                </svg>
            </div>
        </div>
    );
};

export default MedicalCertificatesBt;
